module.exports = __webpack_public_path__ + "img/404CN.cb2d3c84.png";